/**
 * Trả về `indicators` đã sắp lại sao cho mọi series cha luôn nằm trước series con.
 *
 * Duyệt theo `forEach` nên thứ tự vào giữ nguyên với thứ tự đã sắp; chỉ chuỗi hậu
 * duyệt là đảo chiều khi phụ thuộc. `visited` chống hồi quy vô hạn khi ba series
 * trỏ vòng lại nhau.
 */
export function resolveCalculationOrder(indicators) {
    const visited = new Set();
    const order = [];
    function getSeriesId(s) {
        return s.id || `${s.type}:${JSON.stringify(s.params || {})}:${s.sourceType || ""}:${s.sourceId || ""}:${s.sourceKey || ""}`;
    }
    function visit(instance) {
        const id = getSeriesId(instance);
        if (visited.has(id))
            return;
        if (instance.sourceType === "indicator" && instance.sourceId) {
            const parent = indicators.find(ind => ind.id === instance.sourceId);
            if (parent) {
                visit(parent);
            }
        }
        visited.add(id);
        order.push(instance);
    }
    indicators.forEach(instance => visit(instance));
    return order;
}
